import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const items = [
  {
    q: "Is this a dating app?",
    a: "Yes — but built around fitness. Profiles lead with training style, goals, and gym routine, not just photos. The result: deeper compatibility, less small talk.",
  },
  {
    q: "How does matching work?",
    a: "We surface partners based on your training discipline, schedule, location, and goals. When two people mutually opt in, you get a 72-hour window to meet up.",
  },
  {
    q: "What is the 72-hour window?",
    a: "Once you match, you have 72 hours to plan a workout, a meet, or a chat — otherwise the match expires. It's designed to drive real-world action, not endless DMs.",
  },
  {
    q: "Are profiles verified?",
    a: "Every profile is verified through a quick selfie + ID check. Trainers carry an additional verified badge after credential review.",
  },
  {
    q: "How much does it cost?",
    a: "Early access is free during launch. Premium tiers will unlock event hosting, advanced filters, and trainer tools later.",
  },
];

const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="container mx-auto max-w-3xl px-6 md:px-10">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
            Questions
          </p>
          <h2 className="font-heading text-5xl md:text-6xl text-white leading-[0.95]">
            Quick Answers.
            <br />
            <span className="text-neutral-500">No fluff.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {items.map((item, i) => (
            <AccordionItem
              key={item.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading text-xl md:text-2xl text-white tracking-wide hover:text-[#C6FF00] py-6 hover:no-underline"
              >
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-neutral-400 leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
